import Grid from "@mui/material/Grid";
import { Typography, useTheme } from "@mui/material/index";
import { useTranslation } from "react-i18next";
import { FormDateTimePicker, FormTextField } from "../../common/form-fields-wrappers";
import { IExpiredActionInsertionForm } from "../../models/models";

const RaDetails = () => {

    const {t} = useTranslation(['expiredManagement']);
    const theme = useTheme();
    
    return (
        <Grid container >
            <Grid item xs={12}>
                <Typography variant={'h5'} fontWeight={"bold"} color={"primary"}>{t('action.label.raInfo')}</Typography>
            </Grid>
            <Grid item container xs={12} spacing={theme.spacing(2)}>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.raNumber"
                        label={t('expiredDetail.form.raCode')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormDateTimePicker<IExpiredActionInsertionForm> 
                        name="raDetails.raDate"
                        label={t('expiredDetail.form.createdDatetime')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.acriss"
                        label={t('expiredDetail.form.effectiveAcriss')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.plateNumber"
                        label={t('expiredDetail.form.plate')}
                        disabled
                    />
                </Grid>
            </Grid>
            <Grid item container xs={12} spacing={theme.spacing(2)}>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.customerNameSurname"
                        label={t('expiredDetail.form.customerNameSurname')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.companyName"
                        label={t('expiredDetail.form.companyName')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.clientId"
                        label={t('expiredDetail.form.customerSapId')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormTextField<IExpiredActionInsertionForm> 
                        name="raDetails.delayDays"
                        label={t('expiredDetail.form.delayDays')}
                        disabled
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default RaDetails;